import api from 'services/api/microfwk';
import _ from 'lodash';

export const modifyDevice = (params = {}) =>
  api
    .get('/services/device/modify', {
      params,
    })
    .then(({ data }) => {
      const status = _.get(data, 'status', 0);
      if (parseInt(status, 10) === 200) return data.response;
      throw _.get(data, 'errors', 'Unhandled Error');
    })
    .catch(error => {
      const data = _.get(error, 'response.data', false);
      if (data) return data;
      throw error;
    });
